import React, { Component } from 'react';
import axios from 'axios';
import { Avatar, Divider, Modal } from 'antd';
import history from './history';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Popover from '../../components/uielements/popover';
import IntlMessages from '../../components/utility/intlMessages';
import authAction from '../../redux/auth/actions';
import TopbarDropdownWrapper from './topbarDropdown.style';
import { siteConfig } from "../../settings";
import Config from "../../settings/urbanice-api";
import LanguageSwitcher from '../Page/LanguageSwitcher';
import ThemeSwitcher from '../Page/ThemeSwitcher';


const DEBUG = siteConfig.DEBUG
const UNSUBSCRIBE_WEBNITI_NOTI = Config.UNSUBSCRIBE_WEBNITI_NOTI;

const { logout } = authAction;

class TopbarUser extends Component {
  constructor(props) {
    super(props);
    this.handleVisibleChange = this.handleVisibleChange.bind(this);
    this.hide = this.hide.bind(this);
    this.state = {
      visible: false,
      userID: null,
      userImageUrl: null,
      communityID: null,
      communityName: null,
      userFirstname: null,
      userLastname: null,
      fcmToken: null,
      visibleLocale: false,
    };

    this.state.userToken = localStorage.getItem('access_token');
    DEBUG && console.log('UserToken: ' + this.state.userToken);

    this.state.userID = localStorage.getItem('userID');
    DEBUG && console.log('userID: ' + this.state.userID);

    this.state.userImageUrl = localStorage.getItem('userImageUrl');
    DEBUG && console.log('userImageUrl: ' + this.state.userImageUrl);

    this.state.userFirstname = localStorage.getItem("userFirstname");
    DEBUG && console.log("userFirstname: " + this.state.userFirstname);

    this.state.userLastname = localStorage.getItem("userLastname");
    DEBUG && console.log("userLastname: " + this.state.userLastname);

    this.state.communityID = localStorage.getItem('communityID');
    DEBUG && console.log('communityID: ' + this.state.communityID);

    this.state.communityName = localStorage.getItem('communityName');
    DEBUG && console.log('communityName: ' + this.state.communityName);

    this.state.fcmToken = localStorage.getItem("fcmToken");
    DEBUG && console.log("fcmToken: " + this.state.fcmToken);

  }

  hide() {
    this.setState({ visible: false });
  }
  handleVisibleChange() {
    this.setState({ visible: !this.state.visible });
  }

  unsubscribeNotification = () => {
    DEBUG && console.log('topbaruser_unsubscribeNotification');

    let axiosConfig = {
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        Authorization: "Bearer " + this.state.userToken
      },
      data: {
        'fcmToken': this.state.fcmToken,
      }
    };

    axios
      .delete(UNSUBSCRIBE_WEBNITI_NOTI, axiosConfig)
      .then((response) => {
        const resData = response.data
        DEBUG && console.log('topbaruser_unsubscribeNotification_response: ' + JSON.stringify(resData));
        if (resData.isSuccess) {
          DEBUG && console.log('topbaruser_unsubscribeNotification_response: ' + JSON.stringify(resData.isSuccess));
          if (resData.isSuccess) {
            this.logOut();
          }
        }
      })
      .catch((error) => {
        DEBUG && console.log('topbaruser_unsubscribeNotification_response.error: ' + error);
      })
  }

  /***** Log OUT *****/
  logOut = () => {
    DEBUG && console.log('topbaruser_logOut');

    // Clear access token and ID token from local storage
    localStorage.removeItem('id_token');
    window.localStorage.removeItem('communityFeatureList')
    localStorage.removeItem('access_token');
    localStorage.removeItem('userID');
    localStorage.removeItem('userBadgeUrl');
    localStorage.removeItem('userImageUrl');
    localStorage.removeItem('communityName');
    localStorage.removeItem('userFirstname');
    localStorage.removeItem('userLastname');
    localStorage.removeItem('communityID');
    localStorage.removeItem('userDisplayStatus');

    window.localStorage.clear();

    // navigate to the home route
    history.replace('/');

  };

  /****** EXPORT PARCEL MODAL ******/
  showModalLocale = () => {
    this.setState({
      visibleLocale: true,
    });
  };

  handleOkLocale = e => {
    console.log(e);
    this.setState({
      visibleLocale: false,
    });
  };

  handleCancelLocale = e => {
    console.log(e);
    this.setState({
      visibleLocale: false,
    });
  };

  /****** RENDER ******/
  render() {
    const content = (
      <TopbarDropdownWrapper className="isoUserDropdown">
        <a className="isoDropdownLink" >
          <Link to="/dashboard/profile" >
            <IntlMessages id="themeSwitcher.settings" />
          </Link>
        </a>
        {/* <div className="isoDropdownLink" onClick={this.showModalLocale} >
          <a href="# ">
            <IntlMessages id="topbar.locale" />
          </a>
        </div> */}
        <div className="isoDropdownLink" onClick={() => this.unsubscribeNotification()} >
          <a href="# ">
            <IntlMessages id="topbar.logout" />
          </a>
        </div>
      </TopbarDropdownWrapper>


    );

    return (
      <div>
        <Popover
          content={content}
          trigger="click"
          visible={this.state.visible}
          onVisibleChange={this.handleVisibleChange}
          arrowPointAtCenter={true}
          placement="bottomLeft"
        >

          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center' }}>
            <Divider type="vertical" />
            <div style={{ fontFamily: 'Kanit' }} >
              {localStorage.getItem('userFirstname')}{" "}{localStorage.getItem('userLastname')}
            </div>
            <div className="isoImgWrapper">
              {/* <img alt="user" src={userpic} /> */}
              <Avatar src={localStorage.getItem('userImageUrl')} />
              <span className="userActivity online" />
            </div>
          </div>
        </Popover>

        <Modal
          visible={this.state.visibleLocale}
          onOk={this.handleOkLocale}
          onCancel={this.handleCancelLocale}
          destroyOnClose={true}
          footer={null}
        >
          <p>Language Switcher</p>
          <ThemeSwitcher />
          

        </Modal>
      </div>
    );
  }
}
export default connect(
  null,
  { logout }
)(TopbarUser);
